module.exports = __webpack_public_path__ + "static/img/tu7-m@2x.067b3d00.png";